import React from "react";
import { InputFactory, Table } from "../../nq-component";
import { Progress, InfiniteScroll } from "../../nq-component";
import TransactionPresenter from "./TransactionPresenter";
import BaseListPage from "../../base/BaseListPage";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../usecases/object";
import withRouter from "../../withRouter";
import Search from "../../components/Search";
import NavBar from "../../components/navbar";
import { exportCSVUseCase } from "../../usecases/csv/usecases";
import SelectSearch from "../../components/SelectSearch";
import { startOfDay, addDays, addHours, addMinutes, format } from "date-fns";
import { getCurrentUserUseCase } from "../../usecases/user";

class TransactionPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new TransactionPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
      exportCSVUseCase()
    );
    this.state = {
      objects: [],
      selected: [],
      count: "",
      loading: false,
      storeAnalytics: [],
      selectedID: "",
      selectedTranType: "",
      tranDate: "",
      paymentType: "",
      filter: false,
    };
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const user = await getCurrentUserUseCase().execute();
    const storeQuery = { include: ["all"], where: { email: user.email } };
    this.store = await findObjectUseCase().execute("users", storeQuery);
    const store = this.store[0].storeAnalytic.sort((a, b) => {
      const nameA = a.name.toUpperCase(); // ignore upper and lowercase
      const nameB = b.name.toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0; // names must be equal
    });

    this.setState({ storeAnalytics: store });
  }

  getCollectionName() {
    return "transactions";
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    return objects;
  }

  filterSubmit(where) {
    this.presenter.filterSubmit(where);
  }

  setFilter(filter) {
    this.setState({ filter: filter });
  }

  onChangeFilter(filters) {
    const where = {};
    if (filters.store_code) {
      where.store_code = { $regex: filters.store_code, $options: "i" };
    }
    if (filters.tran_type) {
      where.tran_type = { $regex: filters.tran_type, $options: "i" };
    }
    if (filters.paymenttype) {
      where.paymenttype = { $regex: filters.paymenttype, $options: "i" };
    }
    if (filters.tran_date) {
      const startDate = addHours(startOfDay(filters.tran_date), 5);
      const endDate = addMinutes(addHours(addDays(startDate, 1), -1), 59);
      where.tran_date = {
        $gte: format(startDate, "yyyy-MM-dd HH:mm:ss.SSS"),
        $lte: format(endDate, "yyyy-MM-dd HH:mm:ss.SSS"),
      };
    }
    console.warn("WHERE: ", where);
    this.filterSubmit(where);
  }

  onFilterChange = (field, value) => {
    this.setState({ [field]: value }, () => {
      const { selectedID, selectedTranType, paymentType, tranDate } =
        this.state;
      const filters = {
        store_code: selectedID?.value,
        tran_type: selectedTranType?.value,
        paymenttype: paymentType?.value,
        tran_date: tranDate ? new Date(tranDate) : null,
      };
      this.onChangeFilter(filters);
    });
  };

  onClickExport() {
    this.presenter.onClickExport();
  }

  getUniquePaymentTypes() {
    const { objects } = this.state;
    const typesSet = new Set();

    console.log("payment", objects);

    objects.forEach((obj) => {
      if (obj.paymenttype) {
        typesSet.add(obj.paymenttype.toUpperCase());
      }
    });

    return Array.from(typesSet).map((type) => ({
      label: type,
      value: type,
    }));
  }

  edit(index) {
    const object = this.state.objects[index];
    this.navigateTo(`/collection/transactions/form/${object.id}`);
  }

  onCollapse(index) {
    const object = this.state.objects[index];
    const user = this.getCurrentUser();

    // build an array of all the payment entries
    const payments = [
      { label: object.paymenttype, amount: object.paymenttypetotal },
      { label: object.paymenttype2, amount: object.paymenttype2total },
      { label: object.paymenttype3, amount: object.paymenttype3total },
      // add more if you ever have paymenttype4, etc.
    ].filter((p) => p.label); // drop any empty/null entries

    return (
      <div>
        <ul style={{ listStyle: "none", paddingTop: "12px" }}>
          {/* … your other fields here … */}
          <li>
            <strong>Discount Amount:</strong> {object.discount_amount}
          </li>
          <li>
            <strong>Status:</strong> {object.status}
          </li>
          <li>
            <strong>Store Code:</strong> {object.store_code}
          </li>
          <li>
            <strong>Total:</strong> {object.total}
          </li>
          <li>
            <strong>Total Pretax:</strong> {object.total_pretax}
          </li>
          <li>
            <strong>Total Tax:</strong> {object.total_tax}
          </li>
          <li>
            <strong>Total Tax Free:</strong> {object.total_taxfree}
          </li>
          <li>
            <strong>Transaction Date:</strong> {object.tran_date}
          </li>
          <li>
            <strong>Transaction Type:</strong> {object.tran_type}
          </li>
          <li>
            <strong>Re Open:</strong> {object?.reopen}
          </li>
          <li>
            <strong>Re Open User Id:</strong> {object?.reopen_user_id}
          </li>
        </ul>

        <h4>Payments</h4>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            marginBottom: "12px",
          }}
        >
          <thead>
            <tr>
              <th
                style={{
                  textAlign: "left",
                  borderBottom: "1px solid #ccc",
                  padding: "4px",
                  backgroundColor: "#83c14a",
                  color: "white",
                }}
              >
                Method
              </th>
              <th
                style={{
                  textAlign: "right",
                  borderBottom: "1px solid #ccc",
                  padding: "4px",
                  backgroundColor: "#83c14a",
                  color: "white",
                }}
              >
                Amount
              </th>
            </tr>
          </thead>
          <tbody>
            {payments.map((p, i) => (
              <tr key={i}>
                <td style={{ padding: "4px", borderBottom: "1px solid #eee" }}>
                  {p.label}
                </td>
                <td
                  style={{
                    padding: "4px",
                    textAlign: "right",
                    borderBottom: "1px solid #eee",
                  }}
                >
                  {p.amount}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {user.email === "admin@figaro.com" && (
          <button
            className="btn"
            style={{ backgroundColor: "#83c14a", color: "white" }}
            onClick={() => this.edit(index)}
          >
            Edit
          </button>
        )}
      </div>
    );
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, selected, count, storeAnalytics } = this.state;
    const loading = this.state.loading;
    const unique = new Set();
    storeAnalytics.forEach((item) => {
      unique.add(item);
    });
    const selectableItem = Array.from(unique);

    if (!schema) return <Progress />;
    return (
      <>
        <NavBar
          action={() => {
            return (
              <div className="dropdown dropstart d-inline-block">
                <i
                  role="button"
                  data-bs-toggle="dropdown"
                  className="bi bi-three-dots-vertical"
                ></i>
                <div className="dropdown-menu  ">
                  <button
                    className="btn w-100 text-white "
                    style={{ backgroundColor: "#64c339", borderRadius: "12px" }}
                    onClick={this.onClickExport.bind(this)}
                  >
                    <i className="fas fa-file-csv me-2"></i> Export CSV
                  </button>
                </div>
              </div>
            );
          }}
        />
        <div className="overflow-auto">
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            hasMore={!loading && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div className="d-flex justify-content-between align-items-center">
                <h1
                  className="fw-bold text-capitalize"
                  style={{ color: "#83c14a" }}
                >
                  {schema.label || this.getCollectionName()}
                </h1>
                {selected.length > 0 ? (
                  <div>
                    <span className="ms-2">Selected: </span>
                    <span className="fs-sm text-nowrap">{selected.length}</span>
                    <span className="ms-1">of </span>
                    <span className="fs-sm text-nowrap">{count}</span>
                  </div>
                ) : (
                  <div>
                    <span className="ms-2">Total: </span>
                    <span className="fs-sm text-nowrap">{objects.length}</span>
                    <span className="ms-1">of </span>
                    <span className="fs-sm text-nowrap">{count}</span>
                  </div>
                )}
              </div>
              <div className="d-flex mt-3">
                {Object.keys(schema.filters || {}).map((field) => {
                  let { type, ...options } = schema.filters[field];
                  return (
                    <InputFactory
                      key={field}
                      className="ms-1"
                      type={type}
                      field={field}
                      where={{}}
                      onChange={this.onChangeFilter.bind(this, type)}
                      {...options}
                    />
                  );
                })}
              </div>
              <div className="row ms-1 d-flex gap-2">
                {[
                  "selectedID",
                  "selectedTranType",
                  "tranDate",
                  "paymentType",
                ].map((item) => {
                  return (
                    <div className="col-lg-3 p-0" key={item}>
                      {item === "tranDate" ? (
                        <InputFactory
                          type="Date"
                          value={this.state[item]}
                          onChange={(value) =>
                            this.onFilterChange("tranDate", value)
                          }
                        />
                      ) : (
                        <SelectSearch
                          value={this.state[item]}
                          onClickClear={() =>
                            this.onFilterChange(item, { label: "", value: "" })
                          }
                          onChange={(value) =>
                            item === "selectedID"
                              ? this.onFilterChange("selectedID", value)
                              : item === "selectedTranType"
                              ? this.onFilterChange("selectedTranType", value)
                              : this.onFilterChange("paymentType", value)
                          }
                          options={
                            item === "selectedID"
                              ? selectableItem.map((type) => ({
                                  label: type.name,
                                  value: type.name,
                                }))
                              : item === "selectedTranType"
                              ? ["G", "U", "F", "T", "D"].map((type) => ({
                                  label: type,
                                  value: type,
                                }))
                              : this.getUniquePaymentTypes()
                          }
                          placeholder={
                            item === "selectedID"
                              ? "Select Store"
                              : item === "selectedTranType"
                              ? "Select Transaction Type"
                              : item === "paymentType"
                              ? "Select Payment Type"
                              : "Select Date"
                          }
                          disabled={
                            item === "paymentType" &&
                            (!this.state?.objects ||
                              this.state.objects.length === 0)
                          }
                        />
                      )}
                    </div>
                  );
                })}
              </div>

              <Search
                schemas={this.getSchemas()}
                className="mt-3"
                onSubmit={this.searchSubmit.bind(this)}
                fields={schema.fields}
              />
              <Table
                fields={schema.fields}
                objects={objects}
                selectable
                collapsable
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  [
                    "acl",
                    "password",
                    "id",
                    "createdAt",
                    "updatedAt",
                    "status",
                    "window",
                    "tran_type",
                    "remarks",
                    "discount_id",
                    "discount",
                    "discount_amount",
                    "discount_name",
                    "user_id",
                    "reason",
                    "total_pretax",
                    "total_tax",
                    // "paymenttype",
                    "cod",
                    "cust_count",
                    "total_tender",
                    "total_change",
                    "total_taxfree",
                    "changes",
                    "cust_name",
                    "cust_barangay",
                    "cust_address",
                    "cust_phone",
                    "cust_mobile",
                    "cust_email",
                    "cust_birthday",
                    "cust_card",
                    "cust_notes",
                    "landmark",
                    "apcnumber",
                    "deltime",
                    "zyllem",
                    "paymenttype",
                    "paymenttypetotal",
                    "paymenttype2",
                    "paymenttype2total",
                    "paymenttype3",
                    "paymenttype3total",
                    // "reopen",
                    "reopen_user_id",
                  ]
                )}
                selected={selected}
                onSelect={this.onSelect.bind(this)}
                onSelectAll={this.onSelectAll.bind(this)}
                onCollapse={this.onCollapse.bind(this)}
                progress={this.state.filter}
                onClickItem={this.onClickItem.bind(this)}
                className="mt-3"
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default withRouter(TransactionPage);
